import moment from 'moment';
import Vue from 'vue';
import VueCal from 'vue-cal';
import 'vue-cal/dist/i18n/de.js';
import 'vue-cal/dist/vuecal.css';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../util';
import './calendar.css';
import Service from './calendar.service';

declare var window: WindowType;

@Component({
    name: 'CalendarComponent',
    components: {
        VueCal // see https://antoniandre.github.io/vue-cal/#ex--calendar-themes
    }
})
export default class CalendarComponent extends Vue {
    events: Array<any> = [];
    service = new Service();
    
    private loadTimeout?: number;

    mounted() {
        console.info('vue.js CalendarComponent is ready');
        this.service.fetchevents().then(
            data => { this.events = data }
        )
    }

    fetchEvents(view: any) {
        //console.log('Fetching events', view, view.startState, view.endDate );

        let fmt2 = 'DDD MMM  DD YYYY';
        let tgtFmt = 'YYYY-MM-DD';
        if (view.startDate !== undefined && view.endDate !== undefined) {
            let start = moment(view.startDate, fmt2).format(tgtFmt)
            let end = moment(view.endDate, fmt2).format(tgtFmt)

            if (this.loadTimeout) {
                window.clearTimeout(this.loadTimeout);
            }
            this.loadTimeout = window.setTimeout(() => {
                this.service.fetcheventsRange(start, end)
                    .then(data => this.events = data)
            }, 250);
        }
    }

    private onEventClick(event, e): void {
        console.log('event', event);
        window.location.href = window.application.baseUrl + 'quick?duty=' + event.id;
        
        // Prevent navigating to narrower view (default vue-cal behavior).
        e.stopPropagation();
    }
    
    private onEventDoubleClick(event, e): void {
        console.log('d event', event);
        window.location.href = window.application.baseUrl + 'quick?duty=' + event.id;

        // Prevent navigating to narrower view (default vue-cal behavior).
        e.stopPropagation();
    }
}
